// extracted by mini-css-extract-plugin
export default {"title":"S7GCoK","subtitle":"_jvPjn"};